<div class="flex flex-col gap-2">
  @if (label()) {
    <label class="truncate" [ngClass]="smallLabel() ? 'text-sm' : ''" [for]="id()">
      {{ label() | transloco }}
      @if (isRequired()) {
        <span class="text-red" [ngClass]="smallLabel() ? 'text-sm' : ''">*</span>
      }
      @if (tooltipKey()) {
        <app-directus-tooltip class="ml-2" [tooltipKey]="tooltipKey()" />
      }
    </label>
  }

  @if (isReadOnly()) {
    <input
      pInputText
      [value]="formattedReadOnlyValue()"
      [disabled]="true"
      class="w-full readOnly"
    />
  } @else {
    <p-inputNumber
      [id]="id()"
      [attr.data-testid]="id() + '-input'"
      [(ngModel)]="value"
      [min]="0"
      [max]="100"
      suffix="%"
      [minFractionDigits]="minFractionDigits()"
      [maxFractionDigits]="maxFractionDigits()"
      [placeholder]="placeholder() || (label() | transloco)"
      [invalid]="isInvalid()"
      fluid="true"
      (onBlur)="markAsTouched()"
    >
    </p-inputNumber>
  }
</div>
